import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["selectCity", "selectClub", "returnToCityList", "selectedCity"]

    connect() {
        this.selectClubTarget.style.display = "none";

        const cityEntries = this.selectCityTarget.querySelectorAll(".google-reviews__entry");
        cityEntries.forEach(entry => {
            entry.addEventListener("click", this.handleCitySelection.bind(this));
        });

        this.returnToCityListTarget.addEventListener("click", this.returnToCityList.bind(this));
    }

    handleCitySelection(event) {
        const cityElement = event.currentTarget.closest("[data-city-id]");
        const cityId = cityElement.getAttribute("data-city-id");
        const cityName = event.currentTarget.textContent.trim();

        if (cityElement.hasAttribute("data-single-club-link")) {
            const reviewLink = cityElement.getAttribute("data-single-club-link");
            window.open(reviewLink, '_blank');
            return;
        }

        this.selectCityTarget.querySelectorAll("[data-city-id]").forEach(city => {
            city.querySelector(".google-reviews__entry").classList.remove("active");
        });

        this.selectedCityTarget.textContent = cityName;

        this.selectClubTarget.style.display = "block";
        this.selectCityTarget.style.display = "none";

        this.filterClubsByCity(cityId);
    }

    filterClubsByCity(cityId) {
        const clubElements = this.selectClubTarget.querySelectorAll("[data-city-id]");

        clubElements.forEach(club => {
            if (club.getAttribute("data-city-id") === cityId) {
                club.style.display = "block";
            } else {
                club.style.display = "none";
            }
        });
    }

    returnToCityList() {
        this.selectClubTarget.style.display = "none";
        this.selectCityTarget.style.display = "block";
    }
}
